import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";
import {useHistory} from "react-router-dom";

import {Box} from "@mui/material";

import VariantBadge from "components/dashboard/VariantBadge";

import ProductImage from "../../../../TopTablesComponents/ProductImage";
import StockTag from "./StockTag";
import StatusTag from "./StatusTag";

import {greyishBlue100, greyishBlue600} from "assets/jss/main";

import {MarketplaceRoutes} from "utils/MarketplaceRoutes";
import {navigateOnClick} from "utils/navigateOnClick";

TopProductMobileRow.propTypes = {
    product: PropTypes.object.isRequired,
    rank: PropTypes.number.isRequired
};

function TopProductMobileRow({product, rank}) {
    const { id, name, brand, image, sales = 0, stock = 0, status, variants = [], sku, retailerId } = product ?? {};
    const history = useHistory();

    return (
        <div
            onClick={(e) => navigateOnClick(e, MarketplaceRoutes.RETAILER_PRODUCT(retailerId, id), history)}
            style={{
                display: 'flex',
                flexDirection: 'row',
                padding: '14px',
                background: '#fff',
                marginBottom: '10px',
                border: `1px solid ${greyishBlue100}`,
                borderRadius: '12px',
                gap: '12px',
                cursor: 'pointer'
            }}
        >
            <div>
                <ProductImage rank={rank} image={image} name={name}/>
            </div>
            <div style={{display: "flex", flexDirection: "column", gap: "4px"}}>
                <div style={{display: "flex", flexDirection: "row", alignItems: "center", gap: '10px'}}>
                    <div style={{fontSize: '13px'}}>
                        <b>{sales ?? 0}</b>
                        <span style={{fontSize: '10px', color: greyishBlue600}}>&nbsp; <FormattedMessage id="dashboard.topProducts.mobile.sales" /></span>
                    </div>
                    <StockTag stock={stock} />
                    <StatusTag status={status} />
                </div>
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
                    {variants.map((v, i) => (
                        <VariantBadge key={i} value={v} />
                    ))}
                </Box>
                <div style={{fontSize: '11px', color: greyishBlue600}}>
                    <FormattedMessage id="dashboard.common.ref" />. <span style={{fontWeight: 500}}>{sku}</span>
                </div>
                <div style={{
                    fontSize: '12px',
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden'
                }}>
                    <b>{brand}</b> - {name}
                </div>
            </div>
        </div>
    );
}

export default TopProductMobileRow;
